
import Vue from 'vue';
import {Component, Prop, Watch} from "vue-property-decorator";
import {getModule} from "vuex-module-decorators";
import {CustomerModule, ShopModule, store, TradeInModule} from "@returns-centre/store";
import {VueModal} from "@/components";
import {AppButtonSelection, TradeInIneligibleProductModal} from "@returns-centre/components";
import { getItemImage } from '@returns-centre/utils';
import questionMarkIcon from '@returns-centre/resources/questionMarkIcon.svg';
import {find, findIndex, isEmpty} from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import _ from 'lodash';

@Component({
    components: {
        AppButtonSelection,
        VueModal,
        TradeInIneligibleProductModal
    }
})
export default class TradeInProductRegistrationQuestionsModal extends Vue {
    @Prop({default: ''}) category!: Category;
    @Prop({default: ''}) categoryPath!: string;
    @Prop({default: null}) productOption!: ProductOption;
    @Prop({default: null}) selectedTradeInProductRecord!: TradeInProductRecord;
    @Prop({default: []}) bloodline!: Category[];

    questionMarkIcon = questionMarkIcon;
    customerModule = getModule(CustomerModule, store);
    shopModule = getModule(ShopModule, store);
    tradeInModule = getModule(TradeInModule, store);

    isUpdating: boolean = false;
    hasValidationError: boolean = false;
    selectedConditionAnswerOption: ProductQuestionOption[] = [];
    hasTradeInIneligibleProduct: boolean = false;
    tradeInIneligibleProductTitle: string = '';
    tradeInIneligibleProductContent: string = '';


    tradeInProductRecord: TradeInProductRecord = {
        uuid: uuidv4(),
        name: '',
        location: '',
        estimated_age: '',
        retailer_name: '',
        condition: '',
        credit_offered: 0,
        weight: '',
        weight_unit: '',
        category: '',
        category_parent: '',
        additional_information: '',
        reward_type: 'item-exchange',
        shopify_variant_id: '',
        reward_value: 0,
        variant: null,
        product_answers: [],
        image_url: '',
        product_option_id: null
    };

    get JGSExtraQuestions(): RegisteredProductQuestion[] {
        if (this.shopModule.shop!.shop_domain !== 'just-golf-stuff.myshopify.com') {
            return [];
        }

        let questions: RegisteredProductQuestion[] = [];

        const rootCategory = this.bloodline.find(__ => !__.parent_id);

        if (rootCategory && [23551].includes(rootCategory.id)) {
            const question = this.shopModule.shop!.registered_product_questions!.find(__ => __.id === 778);
            if (question) {
                questions.push(question);
            }
        }

        if (rootCategory && [23885].includes(rootCategory.id)) {
            const question = this.shopModule.shop!.registered_product_questions!.find(__ => __.id === 782);
            if (question) {
                questions.push(question);
            }
        }

        if (rootCategory && [23553].includes(rootCategory.id)) {
            const question = this.shopModule.shop!.registered_product_questions!.find(__ => __.id === 781);
            if (question) {
                questions.push(question);
            }
        }

        if (rootCategory && [23894, 23890].includes(rootCategory.id)) {
            const question = this.shopModule.shop!.registered_product_questions!.find(__ => __.id === 783);
            if (question) {
                questions.push(question);
            }
        }

        if (rootCategory && [23551, 23553, 23885, 23894].includes(rootCategory.id)) {
            const question = this.shopModule.shop!.registered_product_questions!.find(__ => __.id === 780);
            if (question) {
                questions.push(question);
            }
        }

        return questions;
    }

    get questions(): RegisteredProductQuestion[] {
        return [
            ...this.shopModule.shop?.registered_product_questions?.filter(__ => ![778, 782, 781, 783, 780].includes(__.id as number)) ?? [],
            ...this.JGSExtraQuestions,
        ];
    }

    async created() {
        this.setConditionQuestionAnswerOptionStyle();
        if(this.selectedTradeInProductRecord) {
          this.isUpdating = true;
          this.tradeInProductRecord = this.selectedTradeInProductRecord;
          return;
        }

        if(this.productOption) {
            this.isUpdating = false;
            this.tradeInProductRecord.name = this.productOption.name;
            this.tradeInProductRecord.credit_offered = this.productOption.credit_offered;
            this.tradeInProductRecord.weight = this.productOption.weight;
            this.tradeInProductRecord.weight_unit = this.productOption.weight_unit;
            this.tradeInProductRecord.category = this.categoryPath;
            this.tradeInProductRecord.category_parent = this.category.name;
            this.tradeInProductRecord.category_id = this.category.id;
            this.tradeInProductRecord.additional_information = this.category.additional_information;
            this.tradeInProductRecord.reward_type = this.productOption.reward_type;
            this.tradeInProductRecord.shopify_variant_id = this.productOption.shopify_variant_id;
            this.tradeInProductRecord.reward_value = this.productOption.reward_value;
            this.tradeInProductRecord.variant = this.productOption.variant;
            this.tradeInProductRecord.image_url = this.productOption.image_url;
            this.tradeInProductRecord.product_option_id = this.productOption.id;
        }

      const ignoredStores = [''];
      if (ignoredStores.includes(this.shopModule.shop!.shop_domain)) {
        await this.tradeInModule.updateTradeInProductRecord(this.tradeInProductRecord);
        this.$emit('close');
      }
    }

    mounted() {
        this.setConditionQuestionAnswerOptionStyle();

        if (!this.questions.length) {
            this.confirm();
        }
    }

    resolveQuestionAttributeSelectedValue(question: RegisteredProductQuestion) {
        if(!this.isUpdating) { return  null;}

        const result = find(this.tradeInProductRecord.product_answers, ['question', question.question_name]);
        if(!result) { return  null;}

        if(question.question_type!.slug == 'condition') {
            setTimeout(() => this.setConditionQuestionAnswerOptionStyle(question, result.answer), 500);
            return {};
        }
        return result;
    }

    doesQuestionsAnswerRequiresAdditionalInput(
        question: RegisteredProductQuestion,
        staticAnswerOptionValue = 'Someone else'
    ) {

        return (findIndex(this.tradeInProductRecord.product_answers, {
            question: question.question_name,
            answer: staticAnswerOptionValue
        }) >= 0);
    }

    setConditionQuestionAnswerOptionStyle(question: RegisteredProductQuestion|null = null, answer: string|null = null) {

        for (const key of Object.keys(this.$refs)) {
            if(key.includes('conditionQuestionAnswerOption_' + question?.id)) {
                // @ts-ignore
                (this.$refs[key][0]! as HTMLDivElement).style.backgroundColor = '#ffffff';
                // @ts-ignore
                (this.$refs[key][0]! as HTMLDivElement).style.color = '#000000';
                // @ts-ignore
                (this.$refs[key][0]! as HTMLDivElement).style.border = '1px solid #000000';
            }
        }

        if(answer) {
            const refName = 'conditionQuestionAnswerOption_' + question?.id + '_' + answer;
            // @ts-ignore
            (this.$refs[refName][0]! as HTMLDivElement).style.backgroundColor = '#000000';
            // @ts-ignore
            (this.$refs[refName][0]! as HTMLDivElement).style.color = '#ffffff';
            // @ts-ignore
            (this.$refs[refName][0]! as HTMLDivElement).style.border = '#000000';
        }
    }

    onOptionSelected(question: RegisteredProductQuestion, answer: string, answerDescription: string = '') {
       this.resolveTradeInProductRecordQuestions(question, answer, answerDescription);
    }

    onTextInputChanged(question: RegisteredProductQuestion, answer: string) {
        this.resolveTradeInProductRecordQuestions(question, answer);
    }

    onOverrideAnswerOptionTextInputChanged(question: RegisteredProductQuestion, answer: string) {
        if(isEmpty(answer)) { return;}
        this.resolveTradeInProductRecordQuestions(question, '', '', answer);
    }

    onConditionQuestionAnswerOptionSelected(
        question: RegisteredProductQuestion,
        option: ProductQuestionOption
    ) {

        this.selectedConditionAnswerOption.push(option);
        this.resolveTradeInProductRecordQuestions(question, option.name, option.description || '');
        this.setConditionQuestionAnswerOptionStyle(question, option.name);
    }

    resolveTradeInProductRecordQuestions(
        question: RegisteredProductQuestion,
        answer: string,
        answerDescription: string = '',
        overrideAnswer: string|null = null
    ) {
        const index = findIndex(this.tradeInProductRecord.product_answers, ['question', question.question_name]);

        if(index < 0) {
            this.tradeInProductRecord.product_answers!.push({
                product_question_id: question.id as number,
                question: question.question_name,
                question_reference: question.question_text!,
                question_type: question.question_type!.slug,
                answer: answer,
                answer_description: answerDescription,
                answer_supplement: overrideAnswer,
                sort_order: question.sort_order!,
            });
        } else {
            this.tradeInProductRecord.product_answers![index].product_question_id = question.id as number;
            this.tradeInProductRecord.product_answers![index].question = question.question_name;
            this.tradeInProductRecord.product_answers![index].question_reference = question.question_text!;
            this.tradeInProductRecord.product_answers![index].question_type = question.question_type!.slug;
            if(!overrideAnswer) {
                this.tradeInProductRecord.product_answers![index].answer = answer
                this.tradeInProductRecord.product_answers![index].answer_supplement = null;
            } else {
                this.tradeInProductRecord.product_answers![index].answer_supplement = overrideAnswer;
            }
            this.tradeInProductRecord.product_answers![index].answer_description = answerDescription;
        }

        const questionText = question.question_text?.toLowerCase();
        if(questionText === 'estimated age') {
            this.tradeInProductRecord.estimated_age = answer;
        }

        if(questionText === 'purchase condition') {
            this.tradeInProductRecord.condition = answer;
        }

        if(questionText === 'purchased from') {
            this.tradeInProductRecord.retailer_name = overrideAnswer || answer;
        }

        if(questionText === 'purchase location') {
            this.tradeInProductRecord.location = answer;
        }
    }

    async confirm() {
        this.hasTradeInIneligibleProduct = false;
        this.tradeInIneligibleProductTitle = '';
        this.tradeInIneligibleProductContent = '';

        const question = this.selectedConditionAnswerOption.find(item => item.ineligible);
        if(question) {
            this.tradeInIneligibleProductTitle = question.ineligible_title!;
            this.tradeInIneligibleProductContent = question.ineligible_description!;
            this.hasTradeInIneligibleProduct = true;
            return;
        }

        const totalQuestions = this.questions.length;
        const answeredQuestions = this.tradeInProductRecord.product_answers!.length;
        this.hasValidationError = false;
        if(answeredQuestions < totalQuestions) {
            this.hasValidationError = true;
            return;
        }

        this.hasValidationError = false;
        for(const question of this.tradeInProductRecord.product_answers!) {
            if(isEmpty(question.answer)) {
                this.hasValidationError = true;
                break;
            }
        }

        if(this.hasValidationError) {
            return;
        }

        this.calculateRewardValue();

        await this.tradeInModule.updateTradeInProductRecord(this.tradeInProductRecord);
        this.$emit('close');
    }

    getProductImage(product: ProductOption): string | null {
        return getItemImage(
            product,
            this.shopModule.shop?.product_image as string,
            this.shopModule.shop?.show_product_images);
    }

    calculateRewardValue(): void {
        // this.tradeInProductRecord.reward_value = this.tradeInProductRecord.reward_value * _.min([1,2]);
    }
}

